import '@fontsource-variable/bricolage-grotesque'
import '@fontsource-variable/newsreader'
import { lazy, StrictMode, Suspense } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { App } from './App'
import { AppProvider } from './state/AppContext'
import './styles.css'

const isAdminHost = window.location.hostname.startsWith('admin.')
const AdminApp = lazy(() => import('./admin/AdminApp').then((m) => ({ default: m.AdminApp })))

if (!isAdminHost && 'serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => navigator.serviceWorker.register('/sw.js'))
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      {isAdminHost
        ? <Suspense fallback={null}><AdminApp /></Suspense>
        : <AppProvider><App /></AppProvider>}
    </BrowserRouter>
  </StrictMode>,
)
